import React from "react";
import ReasonWiseTable from "./ReasonWiseTable";
const ReasonWise = ({ data }) => {
  return (
    <div className="row d-flex justify-content-center">
      <div className="col-md row ">
        <div className="col-md-12 papaDiv">
          <ReasonWiseTable
            from={"Granted Not"}
            data={data.filter((d) => d.Granted_Not === "NOT GRANTED")}
          />
        </div>
        {/* <div className="col-md-12">
          <ReasonWiseTable
            from={"Granted"}
            data={data.filter((d) => d.Granted_Not === "GRANTED")}
          />
        </div> */}
      </div>
      <div className=" col-md row ">
        <div className="col-md-12 papaDiv">
          <ReasonWiseTable
            from={"Availed Not"}
            data={data.filter((d) => d.Availed_Not === "NOT AVAILED")}
          />
        </div>
        {/* <div className="col-md-12">
          <ReasonWiseTable
            from={"Availed"}
            data={data.filter((d) => d.Availed_Not === "AVAILED")}
          />
        </div> */}
      </div>
    </div>
  );
};
export default ReasonWise;
